import { Card, CardContent, Typography } from "@mui/material";
import { useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "styled-components";
import { StyledFormContainer } from "../../components/FormContainer";
import { useApp } from "../../contexts/AppContext";
import EggFreezeForm from "./Form";

const FormContainer: React.FC = () => {
  const infoCardRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const theme = useTheme();

  const { translate } = useApp();
  const translations = useMemo(() => translate("eggfreeze"), [translate]);

  return (
    <StyledFormContainer>
      <Card>
        <CardContent sx={{ padding: theme.spacing(6) }}>
          <Typography variant="h5" sx={{ marginBottom: 2, fontSize: 30 }}>
            {translations.formContainer.calculator.title}
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ color: "#78716C", marginBottom: 2, fontSize: 14 }}
          >
            {translations.formContainer.calculator.description}
          </Typography>
          <EggFreezeForm infoCardRef={infoCardRef} />
        </CardContent>
      </Card>
    </StyledFormContainer>
  );
};

export default FormContainer;
